import React, { useEffect, useState } from 'react';
import { BreadCrumb } from '../src/js/components/BreadCrumb';
import { LoadingOverlay } from '../src/js/components/LoadingOverlay';
import { MainContainer } from '../src/js/components/MainContainer';
import Authorize from '../src/js/components/shared/Authorize';
import { Title } from '../src/js/components/Title';
import { DefaultLayout } from '../src/js/layout/DefautLayout';
import { BreadCrumbItemProp } from '../src/js/types/BreadCrumb';
import { Page } from '../src/js/types/Page';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { Button } from '../src/js/components/Button';
import { Card, CardBody, CardFooter } from '../src/js/components/Cards';
import DateTimeOutput from '../src/js/components/shared/DateTimeOutput';
import {
  KipkaAssessmentListModel,
  OaAssessmentListModel,
} from '../api/assessment-service-api';
import { AssessmentClientWithAuth } from '../services/NSwagWithAuthFactory';
import { UserManagerFactory } from '../services/UserManagerFactory';
import {
  InputMultiDatePicker,
  MultiDatePickerResult,
} from '../src/js/components/inputs/InputMultiDatePicker';
import { InputText } from '../src/js/components/inputs/InputText';
import {
  InputSelect,
  SelectOptions,
} from '../src/js/components/inputs/InputSelect';
import { Pagination } from '../src/js/components/Pagination/Pagination';
import { AnchorLink } from '../src/js/components/AnchorLink';
import { PAGE_MAIN_DASHBOARD } from '../constants/PageCode';
import { ItemPerPagePickerDashboard } from '../src/js/components/Pagination/ItemPerPagePickerDashboard';
import { CollapsibleFilter } from '@src/js/components/CollapsibleFilter';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import OAEmptyData from '@src/js/components/oaEmptyData';

const Index: Page = function () {
  const breadCrumbList: BreadCrumbItemProp[] = [
    {
      name: 'Main Dashboard',
    },
  ];

  const getMasterClient = async () => {
    const userManager = UserManagerFactory();
    const user = await userManager.getUser();

    if (!user) {
      return null;
    }
    const masterClient = await AssessmentClientWithAuth(user);
    return masterClient;
  };

  interface FilterModel {
    typeValue: string;
    companyValue: string;
    startDate: string;
    endDate: string;
    search: string;
    task: string;
  }

  const [isLoading, SetIsLoading] = useState(true);
  const [dataOa, setdataOa] = useState<OaAssessmentListModel[]>([]);
  const [dataKipka, setdataKipka] = useState<KipkaAssessmentListModel[]>([]);
  const [listType, setTypes] = useState<SelectOptions<string>[]>([
    {
      label: '',
      value: '',
    },
  ]);
  const [listCompany, setCompanies] = useState<SelectOptions<string>[]>([
    {
      label: '',
      value: '',
    },
  ]);
  const [filter, setFilter] = useState<FilterModel>({
    typeValue: '',
    companyValue: '',
    startDate: '',
    endDate: '',
    search: '',
    task: '',
  });

  const [currentPageOa, setCurrentPageOa] = useState(1);
  const [DatasPerPageOa, setDatasPerPageOa] = useState(3);
  const [offsetRangeOa] = useState(2);

  const [currentPageKipka, setCurrentPageKipka] = useState(1);
  const [DatasPerPageKipka, setDatasPerPageKipka] = useState(3);
  const [offsetRangeKipka] = useState(2);

  // Get current datas
  const lastDataIndexOa = currentPageOa * DatasPerPageOa;
  const firstDataIndexOa = lastDataIndexOa - DatasPerPageOa;
  const currentDataOa = dataOa.slice(firstDataIndexOa, lastDataIndexOa);
  const [classNameOa, setClassNameOa] = useState<string>();

  const lastDataIndexKipka = currentPageKipka * DatasPerPageKipka;
  const firstDataIndexKipka = lastDataIndexKipka - DatasPerPageKipka;
  const currentDataKipka = dataKipka.slice(
    firstDataIndexKipka,
    lastDataIndexKipka
  );
  const [classNameKipka, setClassNameKipka] = useState<string>();

  function onChangeType(selectedValue: string) {
    const filterData = filter;
    filterData.typeValue = selectedValue;
    setFilter(filterData);
    Search();
  }

  function onChangeCompany(selectedValue: string) {
    const filterData = filter;
    filterData.companyValue = selectedValue;
    setFilter(filterData);
    Search();
  }

  function onChangeSearch(searchValue: string) {
    const filterData = filter;
    filterData.search = searchValue;
    setFilter(filterData);
  }

  function onChangeDate(dates: MultiDatePickerResult) {
    const filterData = filter;
    filterData.startDate = dates[0]?.toISOString() ?? '';
    filterData.endDate = dates[1]?.toISOString() ?? '';
    setFilter(filterData);
    Search();
  }

  function onItemPerPageOaChange(index: number) {
    if (index === 0) {
      index = dataOa.length;
    }
    setDatasPerPageOa(index);
    setCurrentPageOa(1);
  }

  function onItemPerPageKipkaChange(index: number) {
    if (index === 0) {
      index = dataKipka.length;
    }
    setDatasPerPageKipka(index);
    setCurrentPageKipka(1);
  }

  const Search = async () => {
    const masterClient = await getMasterClient();
    if (!masterClient) {
      SetIsLoading(false);
      return;
    }
    SetIsLoading(true);
    const assessmentData =
      await masterClient.dashboard_GetDashboardAssessmentData(
        filter.typeValue,
        filter.companyValue,
        filter.task,
        filter.search,
        filter.startDate,
        filter.endDate
      );
    const oaAssessmentData =
      await masterClient.oaDashboard_GetDashboardAssessmentData(
        filter.typeValue,
        filter.companyValue,
        filter.task,
        filter.search,
        filter.startDate,
        filter.endDate
      );
    setdataOa(oaAssessmentData?.oaAssessmentList ?? []);
    setdataKipka(assessmentData?.kipkaAssessmentList ?? []);
    customeClassNameOa();
    customeClassNameKipka();
    SetIsLoading(false);
  };

  const customeClassNameOa = () => {
    const length = Math.max(
      ...currentDataOa.map((el) => el.assessmentName?.length as number)
    );
    if (length >= 50 && length <= 70) {
      setClassNameOa('fh-220');
    } else if (length > 70) {
      setClassNameOa('fh-270');
    } else {
      setClassNameOa('fh-180');
    }
  };

  const customeClassNameKipka = () => {
    const length = Math.max(
      ...currentDataKipka.map((el) => el.assessmentName?.length as number)
    );
    if (length >= 50 && length <= 70) {
      setClassNameKipka('fh-220');
    } else if (length > 70) {
      setClassNameKipka('fh-270');
    } else {
      setClassNameKipka('fh-180');
    }
  };

  useEffect(() => {
    const InitData = async () => {
      try {
        const masterClient = await getMasterClient();
        if (!masterClient) {
          SetIsLoading(false);
          return;
        }
        const assessmentData =
          await masterClient.dashboard_GetDashboardAssessmentData(
            filter.typeValue,
            filter.companyValue,
            filter.task,
            filter.search,
            filter.startDate,
            filter.endDate
          );
        const oaAssessmentData =
          await masterClient.oaDashboard_GetDashboardAssessmentData(
            filter.typeValue,
            filter.companyValue,
            filter.task,
            filter.search,
            filter.startDate,
            filter.endDate
          );

        if (assessmentData != null) {
          setdataKipka(assessmentData.kipkaAssessmentList ?? []);
        }

        if (oaAssessmentData != null) {
          setdataOa(oaAssessmentData.oaAssessmentList ?? []);

          const typeData = oaAssessmentData.assessmentTypeList ?? [];
          const typeList: SelectOptions<string>[] = [];
          typeData.forEach((company) => {
            typeList.push({
              label: company.label ?? '',
              value: company.value ?? '',
            });
          });

          setTypes(typeList);

          const companyList: SelectOptions<string>[] = [];
          oaAssessmentData.companyList?.forEach((company) => {
            companyList.push({
              label: company.label ?? '',
              value: company.value ?? '',
            });
          });

          setCompanies(companyList);
        }

        customeClassNameOa();
        customeClassNameKipka();
        SetIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    InitData();
  }, []);

  const renderProgressString = (
    type: string,
    status: string,
    done: number,
    totalData: number
  ) => {
    const progress = (done / totalData) * 100;
    if (status === 'Not Completed') {
      if (progress === 100) {
        return type + ' Progress (' + progress.toFixed(2) + '%)';
      } else if (Number.isNaN(progress)) {
        return type + ' Progress (0.00%)';
      } else {
        return type + ' Progress (' + progress.toFixed(2) + '%)';
      }
    }
    return;
  };

  const AssessmentCardOa: React.FunctionComponent<{
    datas: OaAssessmentListModel[];
  }> = function ({ datas }) {
    const card =
      datas.length > 0 &&
      datas.map((data, index) => {
        return (
          <div className='py-3 col-md-4' key={index}>
            <Card className='h-100'>
              <CardBody
                href={`/dashboard/oa/${data.assessmentId}`}
                className={'p-2 text-dark ' + classNameOa}
              >
                <div className='p-0 m-0 row position-relative'>
                  <div className='p-2 col-sm-5 card-logo'>
                    <div>
                      <img
                        className='w-100 h-100'
                        src={data.companyLogoUrl}
                        alt='company logo'
                      />
                    </div>
                  </div>
                  <div className='p-2 col-sm-7'>
                    <div className='p-0'>
                      <p className='mb-1 card-text'>{data.assessmentCode}</p>
                      <p className='mb-1 card-text'>{data.assessmentName}</p>
                      <p className='mb-1 card-text'>
                        <DateTimeOutput isoValue={data.startDate} />
                      </p>
                      <p className='mb-1 card-text'>
                        <DateTimeOutput isoValue={data.endDate} />
                      </p>
                      <p className='mb-1 card-text fw-bold'>{data.status}</p>
                      <p className='mb-1 card-text fw-bold'>
                        {renderProgressString(
                          'Interview',
                          data.status as string,
                          data.totalInterviewDone,
                          data.totalInterview
                        )}
                      </p>
                      <p className='mb-1 card-text fw-bold'>
                        {renderProgressString(
                          'Evidences',
                          data.status as string,
                          data.totalEvidenceDone,
                          data.totalEvidence
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </CardBody>
              <CardFooter
                href={`/dashboard/oa/${data.assessmentId}`}
                className='text-center d-flex align-items-center justify-content-center card-footer-55'
              >
                {data.companyName}
              </CardFooter>
            </Card>
          </div>
        );
      });
    return <React.Fragment>{card}</React.Fragment>;
  };

  const AssessmentCardKipka: React.FunctionComponent<{
    datas: KipkaAssessmentListModel[];
  }> = function ({ datas }) {
    const card =
      datas.length > 0 &&
      datas.map((data, index) => {
        return (
          <div className='py-3 col-md-4' key={index}>
            <Card className='h-100'>
              <CardBody
                href={`/dashboard/kipka/${data.assessmentId}`}
                className={'p-2 text-dark ' + classNameKipka}
              >
                <div className='p-0 m-0 row position-relative'>
                  <div className='p-2 col-sm-5 card-logo'>
                    <div>
                      <img
                        className='w-100 h-100'
                        src={data.companyLogoUrl}
                        alt='company logo'
                      />
                    </div>
                  </div>
                  <div className='p-2 col-sm-7'>
                    <div className='p-0'>
                      <p className='mb-1 card-text'>{data.assessmentCode}</p>
                      <p className='mb-1 card-text'>{data.assessmentName}</p>
                      <p className='mb-1 card-text'>
                        <DateTimeOutput isoValue={data.startDate} />
                      </p>
                      <p className='mb-1 card-text'>
                        <DateTimeOutput isoValue={data.endDate} />
                      </p>
                    </div>
                  </div>
                </div>
              </CardBody>
              <CardFooter
                href={`/dashboard/kipka/${data.assessmentId}`}
                className='text-center d-flex align-items-center justify-content-center card-footer-55'
              >
                {data.companyName}
              </CardFooter>
            </Card>
          </div>
        );
      });
    return <React.Fragment>{card}</React.Fragment>;
  };

  const RenderFilter = () => {
    return (
      <React.Fragment>
        <div>
          <div className='row '>
            <div className='col-md-8'>
              <div className='form-group row'>
                <label className='col-sm-3 col-form-label'>Assessment</label>
                <div className='col-sm-4'>
                  <InputSelect
                    name='inputAssessmentFilter'
                    placeholder='OA / KIPKA'
                    onChange={(e) => onChangeType(e)}
                    options={listType}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='mt-3 row'>
            <div className='col-md-8'>
              <div className='form-group row'>
                <label className='col-sm-3 col-form-label'>
                  Filter by Company
                </label>
                <div className='col-sm-4'>
                  <InputSelect
                    name='inputCompanyFilter'
                    placeholder='Select Company..'
                    onChange={(e) => onChangeCompany(e)}
                    options={listCompany}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='mt-3 row'>
            <div className='col-md-8'>
              <div className='form-group row'>
                <label className='mt-2 col-sm-3 col-form-label'>
                  {'Start & End Date'}
                </label>
                <div className='col-sm-4'>
                  <InputMultiDatePicker
                    onChange={(e) => onChangeDate(e)}
                    placeholder='dd/mm/yyyy - dd/mm/yyyy'
                  />
                </div>
              </div>
            </div>
            <div className='col-md-4'>
              <div className='form-group row'>
                <div className='col-sm-8'>
                  <InputText
                    name='assesseeSearchField'
                    placeholder='Search assessment here..'
                    onChange={(e) => onChangeSearch(e)}
                  ></InputText>
                </div>
                <div className='col-sm-2'>
                  <Button
                    className='oa-btn btn btn-primary'
                    onClick={() => Search()}
                  >
                    Search
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
      </React.Fragment>
    );
  };

  const RenderCheckFilterByType = () => {
    if (filter.typeValue === 'OA') {
      return <React.Fragment>{RenderOaAssessment()}</React.Fragment>;
    } else if (filter.typeValue === 'KIPKA') {
      return <React.Fragment>{RenderKIPKAAssessment()}</React.Fragment>;
    } else {
      return (
        <React.Fragment>
          {RenderOaAssessment()}
          {RenderKIPKAAssessment()}
        </React.Fragment>
      );
    }
  };

  const RenderOaAssessment = () => {
    return (
      <React.Fragment>
        <h2 className='text-center'>OA Assessment</h2>
        <br />
        {currentDataOa.length > 0 ? (
          <div className='my-2 row'>
            <AssessmentCardOa datas={currentDataOa}></AssessmentCardOa>
          </div>
        ) : (
          <div className='my-5 text-center'>
            <OAEmptyData text='Data not Found' />
          </div>
        )}

        <div className='row'>
          <div className='col-5'>
            <hr />
          </div>

          <div className='text-center col-2'>
            <AnchorLink
              href='/dashboard/oa/'
              className='btn btn-outline-secondary'
            >
              <span>
                <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>
              </span>
              &nbsp; See More
            </AnchorLink>
          </div>

          <div className='col-5'>
            <hr />
          </div>
        </div>
        <div className='flex-row d-flex'>
          <Pagination
            dataLength={dataOa.length}
            dataPerPage={DatasPerPageOa}
            offsetRange={offsetRangeOa}
            currentPage={currentPageOa}
            onPageChange={setCurrentPageOa}
          ></Pagination>
          <ItemPerPagePickerDashboard
            onChange={(e) => onItemPerPageOaChange(e)}
          />
        </div>
        <br />
      </React.Fragment>
    );
  };

  const RenderKIPKAAssessment = () => {
    return (
      <React.Fragment>
        <h2 className='text-center'>KIPKA</h2>
        <br />

        {currentDataKipka.length > 0 ? (
          <div className='my-2 row'>
            <AssessmentCardKipka datas={currentDataKipka}></AssessmentCardKipka>
          </div>
        ) : (
          <div className='my-5 text-center'>
            <OAEmptyData text='Data not Found' />
          </div>
        )}

        <div className='row'>
          <div className='col-5'>
            <hr />
          </div>

          <div className='text-center col-2'>
            <AnchorLink
              href='/dashboard/kipka/'
              className='btn btn-outline-secondary'
            >
              <span>
                <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>
              </span>
              &nbsp; See More
            </AnchorLink>
          </div>

          <div className='col-5'>
            <hr />
          </div>
        </div>
        <div className='flex-row d-flex'>
          <Pagination
            dataLength={dataKipka.length}
            dataPerPage={DatasPerPageKipka}
            offsetRange={offsetRangeKipka}
            currentPage={currentPageKipka}
            onPageChange={setCurrentPageKipka}
          ></Pagination>
          <ItemPerPagePickerDashboard
            onChange={(e) => onItemPerPageKipkaChange(e)}
          />
        </div>
      </React.Fragment>
    );
  };

  return (
    <Authorize pageCode={PAGE_MAIN_DASHBOARD}>
      <Title name='Assessment Dashboard'></Title>
      <BreadCrumb itemList={breadCrumbList}></BreadCrumb>
      <LoadingOverlay isLoading={isLoading}></LoadingOverlay>
      <MainContainer>
        <CollapsibleFilter component={RenderFilter()} />
        {RenderCheckFilterByType()}
      </MainContainer>
    </Authorize>
  );
};

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale)),
  },
});

Index.layout = DefaultLayout;
export default Index;
